import AIConversationDetails from "./AIConversationDetails";

export default AIConversationDetails;
